var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.8535,
    cy: 43.8535,
    r: 43.8535,
    fill: "#F2AE33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2813 51.2188H47.2188V48.0313H31.2813V51.2188ZM31.2813 44.8438H55.7188V41.6563H31.2813V44.8438ZM31.2813 38.4688H55.7188V35.2813H31.2813V38.4688ZM23.3125 66.7068V31.154C23.3125 30.0805 23.6844 29.1719 24.4281 28.4281C25.1719 27.6844 26.0805 27.3125 27.154 27.3125H59.846C60.9195 27.3125 61.8281 27.6844 62.5719 28.4281C63.3156 29.1719 63.6875 30.0805 63.6875 31.154V55.346C63.6875 56.4195 63.3156 57.3281 62.5719 58.0719C61.8281 58.8156 60.9195 59.1875 59.846 59.1875H30.8318L23.3125 66.7068ZM29.475 56H59.846C60.0097 56 60.1595 55.9318 60.2955 55.7955C60.4318 55.6595 60.5 55.5097 60.5 55.346V31.154C60.5 30.9903 60.4318 30.8405 60.2955 30.7045C60.1595 30.5682 60.0097 30.5 59.846 30.5H27.154C26.9903 30.5 26.8405 30.5682 26.7045 30.7045C26.5682 30.8405 26.5 30.9903 26.5 31.154V58.9426L29.475 56Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/Chat Icon.68497e2dc9d4ebdcc688279fdd89b758.svg";
export { ForwardRef as ReactComponent };